import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

export default class extends Controller {
  connect() {
    const toast = new Toast(this.element, { delay: 4500 })
    toast.show()
    this.element.addEventListener("hidden.bs.toast", () => this.element.remove())
  }
}
